import ja                           from "date-fns/locale/ja";
import React, { FC }                from "react";
import ReactDatePicker              from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { Button, Icon }             from "semantic-ui-react";
import GetReservations              from "../../../application/usecase/reservation/GetReservations";
import Date                         from "../../../domain/fundamentals/date/Date";
import ReservationRepository        from "../../../domain/reservation/ReservationRepository";
import { ResKaState }               from "../../../index";
import ReservationDataSource        from "../../../infrastructure/datasource/reservation/ReservationDataSource";

const ReservationDateSelector: FC = () => {
  const date: Date = useSelector((state: ResKaState) => state.reservation.detail.date);
  const repository: ReservationRepository = new ReservationDataSource(useDispatch());
  const getReservations: GetReservations = new GetReservations(useDispatch());
  return (
    <>
      <ReactDatePicker
        withPortal
        dateFormat="YYYY/MM/DD"
        locale={ ja }
        onChange={ value => {
          const selectDate: Date = value ? Date.ofText(value.toString()) : date;
          repository.setReservationDate(selectDate);
          getReservations.execute(selectDate);
        } }
        customInput={
          <Button
            icon
            labelPosition="left"
            size="large"
          >
            <Icon name="calendar alternate outline"/>
            { `予約日: ${ date.asText() }` }
          </Button>
        }
      />
    </>
  );
};

export default ReservationDateSelector;
